// --- CLEAN + FIXED VERSION --- //

import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { query, where, collection, onSnapshot, getDocs, orderBy, limit } from "firebase/firestore";
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import { Toast } from "../../components_root/ToastContext.jsx";
import { Randomcode } from "../../components_root/rendom_code.js";
import {
    MdArrowBackIos,
    MdClose,
    MdAccountCircle,
    MdPrint,
    MdSaveAs
} from "react-icons/md";
import "./voucher_entry.css";
import AmountToWords from "../../components_root/AmountToWords.js";
import Ledger_accounts_profile from "../../company_root/staff_account_root/ledger_accounts_profile.jsx";
import { Randomnumber } from "../../components_root/rendom_number.js";
import { Save_Cashbook_withdrawal_voucher_print } from "../cash_book_root/save_cashbook_withdrawal_voucher_print.js";
import Print_vouchers from "../print_root/print_vouchers.js";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools",
    description: "Discover free & premium online services on aooz.",
    keywords: "tools, seo, utilities",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};
// -----------------------
// FORMAT 13 DIGIT ACCOUNT NUMBER
// -----------------------
// export function formatAccountNumber(num, length = 13) {
//     if (!num) return "";
//     return String(num).padStart(length, "0");
// }
export default function Cashbook_withdrawal() {
    const location = useLocation();
    const navigate = useNavigate();
    const { Toastshow } = Toast();
    const servicetablename = "accountingfinancedb";
    const [voucherid, setVoucherid] = useState();
    const [voucher, setVoucher] = useState("");
    const [voucher_type, setVoucher_type] = useState("");
    const [amount, setAmount] = useState("");
    const [totalamount, setTotalamount] = useState(0);
    const [voucherprintid, setVoucherprintid] = useState(Randomcode(22));
    const [vouchernumber, setvouchernumber] = useState(Randomnumber(10));
    //
    const [description, setdescription] = useState("");
    const [slug, setSlug] = useState("");
    const [voucherdate, setVoucherdate] = useState("");
    const [print, setPrint] = useState(false);

    const [fromsearchstatus, setFromsearchstatus] = useState(true);
    const [tosearchstatus, setTosearchstatus] = useState(false);
    const [from_accountdata, setFrom_accountdata] = useState([]);
    const [from_accountguid, setFrom_accountguid] = useState("");
    const [to_accountguid, setTo_accountguid] = useState("");

    const select_company_uid = Cookies.get("select_company_uid");
    const [to_balance, setTo_balance] = useState(0);
    const [balance, setBalance] = useState(0);
    const [printId, setPrintId] = useState();
    // -----------------------
    // SET DATE
    // -----------------------

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const uid = params.get("accountguid");
        const slug = params.get("page");
        if (uid) {
            setFrom_accountguid(uid);

        }
        if (slug) {
            get_voucher(slug);
        }

        else {
            navigate("/?page=cash_book");
        }
    }, [window.location.search]);

    const get_voucher = async (slug) => {
        try {
            const ledgerCollection = collection(
                db,
                servicetablename,
                select_company_uid,
                "vouchers"
            );

            const QueryRef = query(
                ledgerCollection,
                where("status", "==", true),
                where("slug", "==", slug)
            );

            const Snap = await getDocs(QueryRef);

            // SAFE CHECK FIRST
            if (Snap.empty) {
                Toastshow("Voucher does not exist");
                return { success: false, error: "Voucher does not exist." };
            }

            const Doc = Snap.docs[0].data();

            setVoucherid(Doc.voucherid || "");
            setVoucher(Doc.voucher || "");
            setVoucher_type(Doc.voucher_type || "");

            get_account_ledger_master(Doc.voucherid);

            return { success: true };
        } catch (err) {
            console.error("Error loading voucher:", err);
            Toastshow("Error loading voucher");
            return { success: false, error: err.message };
        }
    };

    const get_account_ledger_master = async (voucherid) => {
        const ledgerCollection = collection(
            db,
            servicetablename,
            select_company_uid,
            "ledger_accounts_manager"
        );

        const Query = query(
            ledgerCollection,
            where("account_type", "==", "master"),
            where("status", "==", true),
            where("voucherid", "==", voucherid)
        );

        const Snap = await getDocs(Query);

        if (Snap.empty) {
            Toastshow("Voucher master does not exist");
            return { success: false, error: "Voucher master does not exist." };
        }

        const docData = Snap.docs[0].data();

        setTosearchstatus(true);
        setTo_accountguid(docData.accountguid || "");

        return { success: true };
    };

    useEffect(() => {
        setVoucherdate(new Date().toLocaleString());
    }, [from_accountguid]);
    // -----------------------
    // SEARCH TO ACCOUNT #
    // -----------------------
    useEffect(() => {
        const handle_from_accountgnumber = async (accountnumber) => {
            if (!accountnumber) {
                setTosearchstatus(false);
                return;
            }
            try {
                const snap = await getDocs(
                    query(
                        collection(db, servicetablename, select_company_uid, "ledger_accounts"),
                        where("accountguid", "==", accountnumber)
                    )
                );
                if (!snap.empty) {
                    const list = snap.docs.map((docSnap) => ({
                        id: docSnap.id,
                        ...docSnap.data(),
                    }));
                    setFrom_accountdata(list);
                } else {
                    setFrom_accountdata([]);
                }
            } catch (e) {
                console.error(e);
                setTosearchstatus(false);
            }
        };
        handle_from_accountgnumber(from_accountguid);
    }, [from_accountguid]);

    //save
    const handle_save_voucher = async () => {

            if (from_accountguid === to_accountguid ) {
            Toastshow("Please select different accounts");
            return;
        }
        if (!vouchernumber || !vouchernumber.trim()) {
            Toastshow("Please enter vouchernumber");
            return;
        }

        if (!voucherid || !voucherid.trim()) {
            Toastshow("Please enter voucherid");
            return;
        }
        if (!voucherprintid || !voucherprintid.trim()) {
            Toastshow("Please enter voucherprintid");
            return;
        }

        if (!amount || Number(amount) == 0) {
            Toastshow("Please enter amount");
            return;
        }
        let status = true;
        const payload = {
            voucher,
            description,
            voucherid,
            voucherprintid,
            vouchernumber,
            voucher_type,
            from_accountguid,
            to_accountguid,
            status,
            namepaying: from_accountdata?.name || "",
            accountnumber: from_accountdata?.accountnumber || "",
            mobile: from_accountdata?.mobile || "",
            payment_method_online: false,
            amount: Number(amount) || 0,
            totalamount: Number(totalamount) || 0
        };

        const result = await Save_Cashbook_withdrawal_voucher_print(payload);

        if (result.success) {
            if (print === true) {
                setPrintId(voucherprintid);
            }

            setvouchernumber(Randomnumber(10));
            setVoucherprintid(Randomcode(22));
            setAmount("");
            setTotalamount("");
            setVoucherdate(new Date().toLocaleString());
            Toastshow("Voucher saved successfully.");
        } else {
            Toastshow(result.error || "Failed to save voucher.");
        }
    };


    // -----------------------
    // ESCAPE KEY → BACK
    // -----------------------
    useEffect(() => {
        const handle = (e) => e.key === "Escape" && navigate(-1);
        window.addEventListener("keydown", handle);
        return () => window.removeEventListener("keydown", handle);
    }, []);
    useEffect(() => {
        const sessiontoken = Cookies.get("sessiontoken");
        const guid = Cookies.get("guid");

        if (!sessiontoken || !guid || !select_company_uid) return;

        const ledgerCollection = collection(
            db,
            servicetablename,
            select_company_uid,
            "ledger_books"
        );

        const lastQuery = query(
            ledgerCollection,
            where("accountguid", "==", to_accountguid),
            orderBy("date_time", "desc"),
            limit(1)
        );

        // real-time listener
        const unsubscribe = onSnapshot(
            lastQuery,
            (snapshot) => {
                if (!snapshot.empty) {
                    const balance = snapshot.docs[0].data().balance || 0;
                    setTo_balance(balance);
                } else {
                    setTo_balance(0);
                }
            },
            (error) => {
                setTo_balance(0);
            }
        );

        return () => unsubscribe();

    }, [to_accountguid]);


    //cash_books_accounting
    useEffect(() => {
        const sessiontoken = Cookies.get("sessiontoken");
        const guid = Cookies.get("guid");

        if (!sessiontoken || !guid || !select_company_uid) return;

        const ledgerCollection = collection(
            db,
            servicetablename,
            select_company_uid,
            "cash_books_accounting"
        );

        const lastQuery = query(
            ledgerCollection,
            where("accountguid", "==", from_accountguid),
            orderBy("date_time", "desc"),
            limit(1)
        );

        // real-time listener
        const unsubscribe = onSnapshot(
            lastQuery,
            (snapshot) => {
                if (!snapshot.empty) {
                    const balance = snapshot.docs[0].data().balance || 0;
                    setBalance(balance);
                } else {
                    setBalance(0);
                }
            },
            (error) => {
                setBalance(0);
            }
        );

        // cleanup when unmount or when to_accountguid changes
        return () => unsubscribe();

    }, [to_accountguid]);

    const PrintReceiptVoucher = (id) => {
        setPrintId(id);
    };
    return (
        <div>
            {/* HEADER */}
            <div className="b-bottom">
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <div
                                    onClick={() => navigate("/?page=cash_books")}
                                    className="button-ui0 text-h2 bold p-2 cursor fcap"
                                >
                                    <MdArrowBackIos className="icon" />{voucher}
                                </div>
                            </td>
                            <td width={30}>
                                <div
                                    onClick={() => navigate("/")}
                                    className="button-ui0 p-2 cursor"
                                >
                                    <MdClose className="icon" />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* DATE + RECEIPT */}
            <div className="b-bottom items-back-fill p-11">
                <table>
                    <tbody>
                        <tr>
                            <td className="text-h3"># {vouchernumber}</td>
                            <td width={160} className="text-h3 text-r">
                                Date: {voucherdate}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* BODY */}
            <div className="voucher-entry-body">
                <div className="ui-grid-4-equal m-top">
                    {/* FROM ACCOUNT */}
                    <div className="items-ui">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td width={25}>
                                                        <MdAccountCircle className="icon red" />
                                                    </td>
                                                    <td>
                                                        <div className="text-h2 bold fcap red">
                                                            From account Cashbook
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td><div className="button-ui2 p-2 fill  text-h2">Balance: ₹<div className="bold">{balance}</div> /-</div></td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="items-back-fill rounded">
                                            {fromsearchstatus && (
                                                <>

                                                    <Ledger_accounts_profile accountguid={from_accountguid} />
                                                </>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* TO ACCOUNT */}
                    <div className="items-ui">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td width={25}>
                                                        <MdAccountCircle className="icon green" />
                                                    </td>
                                                    <td>
                                                        <div className="text-h2 bold green">
                                                            To Account Ledger
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>

                                <tr>
                                    <td><div className="button-ui2 cursor p-2 fill  text-h2">Balance: ₹<div className="bold">{to_balance}</div>/-</div></td>
                                </tr>

                                <tr>
                                    <td>
                                        <div className="items-back-fill rounded">

                                            {tosearchstatus && (
                                                <Ledger_accounts_profile accountguid={to_accountguid} />
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* EMPTY */}
                    <div className="items-ui text-r"></div>

                    {/* AMOUNT */}
                    <div className="items-ui text-r">
                        <table>
                            <tbody>

                                <tr>
                                    <td>
                                        <div className="text-h2 fcap text-off">Amount</div>
                                    </td>
                                    <td width={20}>
                                        <span className="text-h1">₹</span>
                                    </td>
                                    <td width={150}>
                                        <input
                                            maxLength={20}
                                            className="p-1 bold text-h1"
                                            placeholder="Enter amount"
                                            value={amount}
                                            onChange={(e) => {
                                                let v = e.target.value.replace(/[^0-9.]/g, "");
                                                const p = v.split(".");
                                                if (p.length > 2) v = p[0] + "." + p.slice(1).join("");
                                                setAmount(v);
                                                setTotalamount(v);
                                            }}
                                        />
                                    </td>
                                    <td width={20}>
                                        <div onClick={() => {
                                            setAmount(balance);
                                            setTotalamount(balance);
                                        }} className="text-h2 cursor text-off">Max</div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* TOTAL */}
                <div className="ui-grid-4-equal m-top b-bottom">
                    <div className="items-ui"></div>
                    <div className="items-ui"></div>
                    <div className="items-ui"></div>

                    <div className="items-ui text-r">
                        <div className="items-back p-11">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>
                                            <div className="text-h2 fcap bold">Total amount</div>
                                        </td>
                                        <td className="text-r">
                                            <span className="text-h1 bold">₹{totalamount}/-</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <AmountToWords amount={amount} />
                        </div>
                    </div>
                </div>

                {/* REMARKS AND PRINT */}
                <div className="ui-grid-4-equal m-top">
                    <div className="items-ui m-1">
                        <input className="bold text-h2" maxLength={200} placeholder="Ref Number option"></input>
                        <textarea
                            className="text-h3"
                            maxLength={300}
                            placeholder="Remark"
                            value={description}
                            onChange={(e) => setdescription(e.target.value)}
                        />

                    </div>

                    <div className="items-ui"></div>
                    <div className="items-ui">

                    </div>

                    <div className="items-ui m-1">
                        <label>
                            <input
                                type="checkbox"
                                checked={print}
                                onChange={(e) => setPrint(e.target.checked)}
                            />
                            <span className="text-h2">I want to save and print.</span>
                        </label>

                        <table>
                            <tr>
                                {print === true ? (
                                    <td>
                                        <div
                                            className="button-ui fill text-h1 p-2 cursor green-back"
                                            onClick={handle_save_voucher}
                                        >
                                            <MdPrint className="icon" /> Print
                                        </div>
                                    </td>
                                ) : (
                                    <td>
                                        <div onClick={handle_save_voucher}
                                            className="button-ui fill text-h1 p-2 cursor"
                                        >
                                            <MdSaveAs className="icon" /> Save
                                        </div>
                                    </td>
                                )}
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            {printId && (
                <Print_vouchers voucherprintid={printId} />
            )}
        </div>
    );
}
